import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const createApplication = ({values, dispatch, token,currentOrgId}) => {
    return ApiClient.post(`${API_URL}/application/create-application?OrganizationId=${currentOrgId}`, values, token, dispatch);
};

export const updateApplication = ({values, dispatch, token, applicationId}) => {
    return ApiClient.put(`${API_URL}/application/update-application?id=${applicationId}`, values, token, dispatch);
};

export const addApplicationForm = ({values, dispatch, token, applicationId}) => {
    return ApiClient.put(`${API_URL}/application/addApplication-form?id=${applicationId}`, values, token, dispatch);
};

export const addApplicationDoc = ({values, dispatch, token, applicationId}) => {
    return ApiClient.put(`${API_URL}/application/addApplication-doc?id=${applicationId}`, values, token, dispatch);
};

export const getAllApplication = ({dispatch, token, listFilter, clinicId}) => {
    return ApiClient.get(`${API_URL}/application/get-application?listFilter=${listFilter}&clinicId=${clinicId}`,null, token, dispatch);
};

export const updateApplicationById = ({payload, dispatch, token, aplnId}) => {
    return ApiClient.put(`${API_URL}/application/update-application?id=${aplnId}`, payload, token, dispatch);
};

export const updateApplicationArchieve = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/update-archieve`, values, token, dispatch);
};

export const getApplicationById = ({ dispatch, token, applicationId}) => {
    return ApiClient.get(`${API_URL}/application/get-applicationById?applicationId=${applicationId}`, null, token, dispatch);
};

export const removeSigner = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/remove-signer?applicationId=${values?.applicationId}&signerId=${values?.signerId}`, {}, token, dispatch);
};

export const updateTask = ({values, dispatch, token, applicationId, taskId, createdBy}) => {
    return ApiClient.put(`${API_URL}/application/update-task?applicationId=${applicationId}&taskId=${taskId}&createdBy=${createdBy}`, values, token, dispatch);
};

export const addTask = ({values, dispatch, token, applicationId, userId}) => {
    return ApiClient.put(`${API_URL}/application/add-task?applicationId=${applicationId}&userId=${userId}`, values, token, dispatch);
};

export const deleteTask = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/delete-task?applicationId=${values?.applicationId}&taskId=${values?.taskId}`, {}, token, dispatch);
};

export const addApplicationReceipt = ({values, dispatch, token, applicationId,patientId}) => {
    return ApiClient.put(`${API_URL}/application/addApplication-receipt?id=${applicationId}&patientId=${patientId}`, values, token, dispatch);
};

export const deleteReceipt = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/delete-receipt?applicationId=${values?.applicationId}&receiptId=${values?.receiptId}`, {}, token, dispatch);
};

export const updateApplicationReceipt = ({values, dispatch, token, applicationId, receiptId}) => {
    return ApiClient.put(`${API_URL}/application/addApplication-receipt?id=${applicationId}&&receiptId=${receiptId}`, values, token, dispatch);
};

export const sendTextMessage = ({payload, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/addApplication-message`, payload, token, dispatch);
};

export const createApplicationActivity = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/application/create-application-activity`, values, token, dispatch);
};

export const getApplicationActivity = ({ dispatch, token, clinicId, type, applicationId, patientId }) => {
    return ApiClient.get(`${API_URL}/application/get-application-activity?clinicId=${clinicId}&type=${type}&applicationId=${applicationId}&patientId=${patientId}`, null, token, dispatch);
};

export const getPatientTrackedApplication = ({ dispatch, token, patientId }) => {
    return ApiClient.get(`${API_URL}/application/get-patient-application?patientId=${patientId}`, null, token, dispatch);
};

export const getPendingTasks = ({ dispatch, token, clinicId }) => {
    return ApiClient.get(`${API_URL}/application/get-tasks?clinicId=${clinicId}`, null, token, dispatch);
};

export const getPatientPendingTasks = ({ dispatch, token, patientId }) => {
    return ApiClient.get(`${API_URL}/application/get-patient-tasks?patientId=${patientId}`, null, token, dispatch);
};

export const getSignedApplicationUrl = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application/aggrement-sign`, values, token, dispatch);
};

export const getAgreementStatus = ({values, dispatch, token}) => {
    return ApiClient.get(`${API_URL}/application/aggrement-status?agreementId=${values.agreementId}`, values, token, dispatch);
};

export const getAllParticipantStatus = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application/aggrement-participant-status`, values, token, dispatch);
};


export const resetAgreement = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/application/reset-agreement`, values, token, dispatch);
};

export const downloadAgreement = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application/download-agreement?agreementId=${values.agreementId}&applicationId=${values.applicationId}`, {values}, token, dispatch);
};

export const sendAgreementViaSMS = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application/signurl-agreement`, values, token, dispatch);
};

export const getDocumentsByPateientId = ({ dispatch, token, patientId}) => {
    return ApiClient.get(`${API_URL}/application/get-patient-applicationDocuments?patientId=${patientId}`, null, token, dispatch);
};

export const sendReminder = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application/send-reminder`, values, token, dispatch);
};

export const getParticipantSignedUrls = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/application//participants-signurl`, values, token, dispatch);
};

//Support

export const createRequest = ({values, dispatch, token,createdBy}) => {
    return ApiClient.post(`${API_URL}/application//support/create-request`, values, token, dispatch,createdBy);
};

export const getAllRequests = ({dispatch, token, listFilter,userId,userRole,clinicId,organizationId}) => {
    return ApiClient.get(`${API_URL}/application/support/get-requests?listFilter=${listFilter}&userId=${userId}&userRole=${userRole}&clinicId=${clinicId}&organizationId=${organizationId}`,null, token, dispatch);
};

export const getSupportDetailById = ({ dispatch, token, supportId}) => {
    return ApiClient.get(`${API_URL}/application/support/get-support-request?supportId=${supportId}`, null, token, dispatch);
};

export const updateSupportRequest = ({values, dispatch, token,supportId}) => {
    return ApiClient.put(`${API_URL}/application/support/update-request?id=${supportId}`, values, token, dispatch);
};

export const updateSupportPlatformRequest = ({values, dispatch, token,supportId}) => {
    return ApiClient.put(`${API_URL}/application/support/update-platform-request?id=${supportId}`, values, token, dispatch);
};

export const updateAttchmentSupportRequest = ({values, dispatch, token,supportId}) => {
    return ApiClient.put(`${API_URL}/application/support/upload-attchment?id=${supportId}`, values, token, dispatch);
};

export const deleteSupportAttachment = ({dispatch, token,supportId , docId}) => {
    return ApiClient.put(`${API_URL}/application/support/delete-attchment?id=${supportId}&docId=${docId}`, {}, token, dispatch);
};
